export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_Indoor_5120000-1efa5c3b3be7cb4f3293b83f5ec22d23.avif";